module.exports = __webpack_public_path__ + "img/img_midgrab-hero_large.0f9d1ad6.jpg";